// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"177":"home","193":"software","443":"about"}[chunkId] + "." + {"177":"911c3311","193":"4d3afeb9","443":"8d770bee"}[chunkId] + ".js";
};